export default "__VITE_ASSET__Cj8QAYN2__"